/* eslint-disable @next/next/no-img-element */
import { ImgHTMLAttributes } from 'react';

type ImageProps = ImgHTMLAttributes<HTMLImageElement>;

export default function Image({ alt, ...props }: ImageProps) {
  return (
    <img
      {...props}
      alt={alt}
      loading="lazy"
      className="h-auto max-w-full w-auto block rounded my-6 md:my-12"
    />
  );
}
